import * as Yup from "yup";

const fixIsNan = (value) => (isNaN(value) ? undefined : value);

export const commonFieldsRulesClose = {
  dateTimeEnable: Yup.string().nullable(true).required("Выберите дату"),
  timeEnable: Yup.string()
    .nullable(true)
    .test(function (val) {
      if (typeof val === "string") {
        return (
          val.length === 5 ||
          !val.length ||
          this.createError({ message: "Проверьте корректность данных" })
        );
      }
      return true;
    })
    .required("Выберите время"),
};

export const commonFieldsRules = {
  dateTimeDisable: Yup.string().nullable(true).required("Выберите дату"),
  timeDisable: Yup.string()
    .nullable(true)
    .test(function (val) {
      if (typeof val === "string") {
        return (
          val.length === 5 ||
          !val.length ||
          this.createError({ message: "Проверьте корректность данных" })
        );
      }
      return true;
    })
    .required("Выберите время"),
  organizationId: Yup.number().nullable(true).required("Выберите РСО"),
  externalId: Yup.number()
    .nullable(true)
    .transform(fixIsNan)
    .required("Введите идентификатор дефекта"),
  eventTypeId: Yup.number().nullable(true).required("Выберите тип события"),
  addressGuid: Yup.string()
    .nullable(true)
    .test("addressGuid", "failureMessage", function (val) {
      if (val === "00000000-0000-0000-0000-000000000000") {
        return this.createError({
          message: "Сотрите адрес и выберите снова",
        });
      }
      return true;
    })
    .required("Выберите адрес дефекта из списка"),
  districtId: Yup.number()
    .nullable(true)
    .required("Выберите административный район"),
  responsible: Yup.string().nullable(true).required("Введите ФИО"),
  responsiblePhone: Yup.string()
    .nullable(true)
    .required("Введите номер телефона"),
  mediaComment: Yup.string()
    .transform((value, original) =>
      original == null || original === "" ? undefined : value,
    )
    .when(["mediaCoverage"], (mediaCoverage, schema) => {
      return mediaCoverage
        ? schema.max(64, "Максимальное значение 64")
        : schema.min(null);
    }),
};

export const mkaRules = {
  mkaUtilitiesSectorId: Yup.string()
    .nullable(true)
    .when("addressAreaId", {
      is: (addressAreaId) => addressAreaId,
      then: Yup.string().typeError("Выберите сферу ЖКХ"),
    }),
  incidentDescription: Yup.string()
    .nullable(true)
    .when("addressAreaId", {
      is: (addressAreaId) => addressAreaId,
      then: Yup.string()
        .nullable(true)
        .required("Введите краткое описание события"),
    }),
  mkaTechonologicalProcessStageId: Yup.string()
    .nullable(true)
    .when("addressAreaId", {
      is: (addressAreaId) => addressAreaId,
      then: Yup.string().typeError("Выберите этап технологического процесса"),
    }),
  mkaObjectKindId: Yup.string()
    .nullable(true)
    .when("addressAreaId", {
      is: (addressAreaId) => addressAreaId,
      then: Yup.string().typeError("Выберите вид объекта"),
    }),
  mkaIncidentTypeId: Yup.string()
    .nullable(true)
    .when("addressAreaId", {
      is: (addressAreaId) => addressAreaId,
      then: Yup.string().typeError("Выберите тип аварии/инцидента"),
    }),
  mkaDecisionStatusId: Yup.string()
    .nullable(true)
    .when("addressAreaId", {
      is: (addressAreaId) => addressAreaId,
      then: Yup.string().typeError("Выберите статус решения аварии/инцидента"),
    }),
  deadCount: Yup.number()
    .nullable(true)
    .when("addressAreaId", {
      is: (addressAreaId) => addressAreaId,
      then: Yup.number()
        .transform(fixIsNan)
        .required("Введите кол-во погибших")
        .min(0, "Не может быть отрицательного значения!"),
    }),
  affectedCount: Yup.number()
    .nullable(true)
    .when("addressAreaId", {
      is: (addressAreaId) => addressAreaId,
      then: Yup.number()
        .transform(fixIsNan)
        .required("Введите кол-во пострадавших")
        .min(0, "Не может быть отрицательного значения!"),
    }),
  weather: Yup.string()
    .nullable(true)
    .when("addressAreaId", {
      is: (addressAreaId) => addressAreaId,
      then: Yup.string().nullable(true).required("Введите погодные условия"),
    }),
  fullListOfLocation: Yup.string()
    .nullable(true)
    .when("fullFact", {
      is: (fullFact) => fullFact,
      then: Yup.string().typeError("Введите перечень населенных пунктов"),
    }),
  fullListOfObjects: Yup.string()
    .nullable(true)
    .when("fullFact", {
      is: (fullFact) => fullFact,
      then: Yup.string().typeError("Ведите перечень объектов"),
    }),
  fullOfMkdPplCount: Yup.string()
    .nullable(true)
    .when("fullFact", {
      is: (fullFact) => fullFact,
      then: Yup.string().typeError(
        "Введите кол-во жителей в многоквартирных домах",
      ),
    }),
  fullOfSocialObjectsCount: Yup.string()
    .nullable(true)
    .when("fullFact", {
      is: (fullFact) => fullFact,
      then: Yup.string().typeError(
        "Введите кол-во объектов социальной инфраструктуры",
      ),
    }),
  fullOfPrivateHousesCount: Yup.string()
    .nullable(true)
    .when("fullFact", {
      is: (fullFact) => fullFact,
      then: Yup.string().typeError(
        "Введите кол-во индивидуальных домовладений",
      ),
    }),
  fullOfPrivateHousesPplCount: Yup.string()
    .nullable(true)
    .when("fullFact", {
      is: (fullFact) => fullFact,
      then: Yup.string().typeError(
        "Введите кол-во жителей индивидуальных домовладений",
      ),
    }),
  fullListOfObjectsOther: Yup.string()
    .nullable(true)
    .when("fullFact", {
      is: (fullFact) => fullFact,
      then: Yup.string().typeError("Введите перечень иных объектов"),
    }),
  fullHouseAddress: Yup.string()
    .nullable(true)
    .when("fullFact", {
      is: (fullFact) => fullFact,
      then: Yup.string().typeError("Введите адрес многоквартирного дома"),
    }),
  fullHousesShutdownPplCount: Yup.string()
    .nullable(true)
    .when("fullFact", {
      is: (fullFact) => fullFact,
      then: Yup.string().typeError("Введите кол-во жителей в доме"),
    }),
  fullOfMkdCount: Yup.string()
    .nullable(true)
    .when("fullFact", {
      is: (fullFact) => fullFact,
      then: Yup.string().typeError("Введите кол-во МКД"),
    }),
  partialListOfLocation: Yup.string()
    .nullable(true)
    .when("partialFact", {
      is: (partialFact) => partialFact,
      then: Yup.string().typeError("Введите перечень населенных пунктов"),
    }),
  partialListOfObjects: Yup.string()
    .nullable(true)
    .when("partialFact", {
      is: (partialFact) => partialFact,
      then: Yup.string().typeError("Ведите перечень объектов"),
    }),
  partialOfMkdPplCount: Yup.string()
    .nullable(true)
    .when("partialFact", {
      is: (partialFact) => partialFact,
      then: Yup.string().typeError(
        "Введите кол-во жителей в многоквартирных домах",
      ),
    }),
  partialOfSocialObjectsCount: Yup.string()
    .nullable(true)
    .when("partialFact", {
      is: (partialFact) => partialFact,
      then: Yup.string().typeError(
        "Введите кол-во объектов социальной инфраструктуры",
      ),
    }),
  partialOfPrivateHousesCount: Yup.string()
    .nullable(true)
    .when("partialFact", {
      is: (partialFact) => partialFact,
      then: Yup.string().typeError(
        "Введите кол-во индивидуальных домовладений",
      ),
    }),
  partialOfPrivateHousesPplCount: Yup.string()
    .nullable(true)
    .when("partialFact", {
      is: (partialFact) => partialFact,
      then: Yup.string().typeError(
        "Введите кол-во жителей индивидуальных домовладений",
      ),
    }),
  partialListOfObjectsOther: Yup.string()
    .nullable(true)
    .when("partialFact", {
      is: (partialFact) => partialFact,
      then: Yup.string().typeError("Введите перечень иных объектов"),
    }),
  partialHouseAddress: Yup.string()
    .nullable(true)
    .when("partialFact", {
      is: (partialFact) => partialFact,
      then: Yup.string().typeError("Введите адрес многоквартирного дома"),
    }),
  partialHousesShutdownPplCount: Yup.string()
    .nullable(true)
    .when("partialFact", {
      is: (partialFact) => partialFact,
      then: Yup.string().typeError("Введите кол-во жителей в доме"),
    }),
  partialOfMkdCount: Yup.string()
    .nullable(true)
    .when("partialFact", {
      is: (partialFact) => partialFact,
      then: Yup.string().typeError("Введите кол-во МКД"),
    }),
  connectedListOfLocation: Yup.string()
    .nullable(true)
    .when("connectedFact", {
      is: (connectedFact) => connectedFact,
      then: Yup.string().typeError("Введите перечень населенных пунктов"),
    }),
  connectedListOfObjects: Yup.string()
    .nullable(true)
    .when("connectedFact", {
      is: (connectedFact) => connectedFact,
      then: Yup.string().typeError("Ведите перечень объектов"),
    }),
  connectedOfMkdPplCount: Yup.string()
    .nullable(true)
    .when("connectedFact", {
      is: (connectedFact) => connectedFact,
      then: Yup.string().typeError(
        "Введите кол-во жителей в многоквартирных домах",
      ),
    }),
  connectedOfSocialObjectsCount: Yup.string()
    .nullable(true)
    .when("connectedFact", {
      is: (connectedFact) => connectedFact,
      then: Yup.string().typeError(
        "Введите кол-во объектов социальной инфраструктуры",
      ),
    }),
  connectedOfPrivateHousesCount: Yup.string()
    .nullable(true)
    .when("connectedFact", {
      is: (connectedFact) => connectedFact,
      then: Yup.string().typeError(
        "Введите кол-во индивидуальных домовладений",
      ),
    }),
  connectedOfPrivateHousesPplCount: Yup.string()
    .nullable(true)
    .when("connectedFact", {
      is: (connectedFact) => connectedFact,
      then: Yup.string().typeError(
        "Введите кол-во жителей индивидуальных домовладений",
      ),
    }),
  connectedListOfObjectsOther: Yup.string()
    .nullable(true)
    .when("connectedFact", {
      is: (connectedFact) => connectedFact,
      then: Yup.string().typeError("Введите перечень иных объектов"),
    }),
  connectedHouseAddress: Yup.string()
    .nullable(true)
    .when("connectedFact", {
      is: (connectedFact) => connectedFact,
      then: Yup.string().typeError("Введите адрес многоквартирного дома"),
    }),
  connectedHousesShutdownPplCount: Yup.string()
    .nullable(true)
    .when("connectedFact", {
      is: (connectedFact) => connectedFact,
      then: Yup.string().typeError("Введите кол-во жителей в доме"),
    }),
  connectedOfMkdCount: Yup.string()
    .nullable(true)
    .when("connectedFact", {
      is: (connectedFact) => connectedFact,
      then: Yup.string().typeError("Введите кол-во МКД"),
    }),
  fullListOfMkd: Yup.array().of(
    Yup.object().shape({
      fullHouseFias: Yup.string().required("Выберите адрес из списка"),
      fullHouseId: Yup.number().transform(fixIsNan).required("Введите HouseId"),
      fullHousesShutdownPplCount: Yup.number()
        .transform(fixIsNan)
        .required("Введите количество жителей в доме"),
    }),
  ),
  connectedListOfMkd: Yup.array().of(
    Yup.object().shape({
      connectedHouseFias: Yup.string().required("Выберите адрес из списка"),
      connectedHouseId: Yup.number()
        .transform(fixIsNan)
        .required("Введите HouseId"),
      connectedHousesShutdownPplCount: Yup.number()
        .transform(fixIsNan)
        .required("Введите количество жителей в доме"),
    }),
  ),
  partialListOfMkd: Yup.array().of(
    Yup.object().shape({
      partialHouseFias: Yup.string().required("Выберите адрес из списка"),
      partialHouseId: Yup.number()
        .transform(fixIsNan)
        .required("Введите HouseId"),
      partialHousesShutdownPplCount: Yup.number()
        .transform(fixIsNan)
        .required("Введите количество жителей в доме"),
    }),
  ),
};
